<template>
  <div class="fts-information-modal">
    <!-- Information Modal -->
    <modal
      class="fts-v-modal"
      :height="'auto'"
      :width="'800px'"
      :scrollable="true"
      :adaptive="true"
      @before-open="beforeOpen"
      name="informationModal"
    >
      <div class="fts-v-modal-header">
        <div class="fts-v-modal-header-title">Information</div>
      </div>

      <div class="fts-v-modal-content">
        <div class="fts-v-modal-content-body">
          <fts-form :fields="form" :formData="formData" :form="form"></fts-form>
          <div v-if="formData.type === 14 || formData.type === 15" class="class-info">
            <div class="content-body-main-label">Fields</div>
            <!-- Classification -->
            <div class="classification-container">
              <div class="classification-information" v-if="formData.fields">
                <draggable
                  v-model="formData.fields"
                  v-bind="dragOptions"
                  handle=".class-info-handle"
                  class="class-info-container"
                >
                  <div
                    v-for="(classInfo, index) in formData.fields"
                    :key="classInfo.information.id"
                    :class="{ 'over': show == index }"
                    @mouseover="show = index"
                    @mouseleave="show = -1"
                    class="class-info-wrapper"
                  >
                    <div class="class-info-inner-wrapper">
                      <div class="class-info-item">
                        <div class="class-info-item-wrapper">
                          <font-awesome-icon
                            :icon="['fas', 'grip-vertical']"
                            fixed-width
                            class="class-info-handle"
                            @click.stop
                          />
                          <i class="class-info-icon" :class="getIcon(classInfo.information.type)"></i>
                          <div
                            class="class-info-display-name"
                            @click="showInformation(classInfo.information)"
                          >{{classInfo.information.displayName}}</div>
                          <span class="fts-badge-legacy" v-if="classInfo.required">Required</span>
                          <span class="fts-badge-legacy" v-if="classInfo.readOnly">Read Only</span>
                          <span class="fts-badge-legacy" v-if="classInfo.due">Due</span>
                          <span class="fts-badge-legacy" v-if="classInfo.assignee">Assignee</span>
                          <span class="fts-badge-legacy" v-if="classInfo.addRemoveItems">Add/Remove Items</span>
                        </div>
                      </div>
                    </div>

                    <div class="class-info-additional-action" v-if="show === index">
                      <span
                        class="fts-badge-legacy"
                        :class="{'active': classInfo.required}"
                        @click.stop="classInfo.required = !classInfo.required"
                      >Required</span>
                      <span
                        class="fts-badge-legacy"
                        :class="{'active': classInfo.readOnly}"
                        @click.stop="classInfo.readOnly = !classInfo.readOnly"
                      >Read only</span>

                      <!-- Visibility Script -->
                      <font-awesome-icon :icon="['far', 'eye']" fixed-width class="edit-action" />
                      <font-awesome-icon
                        :icon="['fas', 'cog']"
                        fixed-width
                        class="edit-action"
                        @click="showInformation(classInfo.information)"
                      />
                      <font-awesome-icon
                        :icon="['fas', 'times']"
                        fixed-width
                        class="remove-action"
                        @click.stop="modalConfirmation('removeInformation', classInfo)"
                      />
                    </div>
                  </div>
                </draggable>
              </div>
            </div>

            <div class="class-info-action">
              <input
                class="fet-form-control"
                v-model="newInformation.displayName"
                :placeholder="'create field'"
                taggable
                label="displayName"
                :options="information"
              />
              <v-select
                v-model="newInformation.typeModel"
                :key-property="'id'"
                @keyUpdate="newInformation.type = $event"
                label="type"
                :text="newInformation && newInformation.typeModel? newInformation.typeModel.type : ''"
                :options="informationTypes"
              ></v-select>
              <button
                type="button"
                class="fts-btn fts-btn-outline fts-btn-primary fts-btn-icon-mr"
                @click="addInformation()"
              >
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width />Add
              </button>
            </div>
          </div>
        </div>

        <div class="fts-v-modal-content-footer">
          <div>
            <button
              v-if="formData.id"
              type="button"
              class="fts-btn fts-btn-text fts-btn-danger fts-btn-icon-mr float-left"
              @click="deleteInformation()"
            >
              <font-awesome-icon :icon="['far', 'trash-alt']" fixed-width />Delete
            </button>
          </div>
          <div>
            <button
              type="button"
              class="fts-btn fts-btn-raised fts-btn-primary fts-btn-icon-mr"
              @click="confirmInformation()"
            >
              <font-awesome-icon :icon="['fas', 'check']" fixed-width />Done
            </button>
          </div>
        </div>

        <font-awesome-icon
          :icon="['fas', 'times']"
          fixed-width
          class="close-action"
          @click="close"
        />
      </div>
    </modal>

    <FTSNestedInformationModal @delete="deleteNested" @confirm="confirmNested"></FTSNestedInformationModal>
  </div>
</template>

<script>
import FETContenteditable from "../FETContenteditable";
import { cloneDeep } from "lodash";
import FTSForm from "../elements/FTSForm";
import commons from "../commons/commons";
import moment from "moment";
import draggable from "vuedraggable";
import vSelect from "../vue-select/index";
import FTSNestedInformationModal from "./FTSNestedInformationModal";

export default {
  mounted() {},
  computed: {
    states() {
      return this.$store.state.canvas.states;
    },
    information() {
      return this.$store.state.canvas.information;
    },
    flows() {
      return this.$store.state.canvas.flows;
    },
    activities() {
      return this.$store.state.canvas.activities;
    }
  },
  data() {
    return {
      dragOptions: commons.dragOptions,
      show: -1,
      newInformation: {},
      dateFormatSelection: commons.dateFormats,
      informationTypes: commons.informationTypes,
      formData: {},
      form: {
        rows: [
          {
            items: [
              {
                displayName: "Name",
                fieldName: "displayName",
                input: "text"
              },
              {
                displayName: "Label (Optional)",
                fieldName: "label",
                input: "text"
              }
            ]
          },
          {
            items: [
              {
                displayName: "Description",
                fieldName: "description",
                input: "textArea"
              }
            ]
          },
          {
            items: [
              {
                displayName: "Type",
                key: "type",
                fieldName: "typeText",
                input: "dropDown",
                displayProperty: "type",
                optionList: commons.informationTypes
              },
              {
                displayName: "Format",
                fieldName: "predefinedFormat",
                input: "dropDown",
                optionList: this.formatSelection(this.formData),
                hiddenFunc: formData => this.hidden("format", formData)
              }
            ]
          },
          {
            items: [
              {
                displayName: "Prefix",
                fieldName: "prefix",
                input: "text",
                hiddenFunc: formData => this.hidden("prefix", formData)
              },
              {
                input: "empty"
              }
            ]
          },
          {
            items: [
              {
                displayName: "With time",
                fieldName: "withTime",
                input: "boolean",
                hiddenFunc: formData => this.hidden("withTime", formData)
              },
              {
                input: "empty"
              }
            ]
          },

          {
            items: [
              {
                displayName: "Lookup",
                fieldName: "connection",
                key: "connectionId",
                input: "dropDown",
                hiddenFunc: formData => this.hidden("lookup", formData)
              },
              {
                displayName: "Preload",
                fieldName: "test",
                input: "boolean",
                hiddenFunc: formData => this.hidden("lookup", formData)
              }
            ]
          },
          {
            items: [
              {
                displayName: "Formula",
                fieldName: "test",
                input: "text",
                hiddenFunc: formData => this.hidden("formula", formData)
              }
            ]
          },
          {
            items: [
              {
                displayName: "Allow multiple",
                fieldName: "allowMultiple",
                input: "boolean",
                hiddenFunc: formData => this.hidden("allowMultiple", formData)
              },
              {
                input: "empty"
              }
            ]
          },
          {
            items: [
              {
                displayName: "Options",
                fieldName: "optionList",
                input: "table",
                columns: [
                  {
                    displayName: "Name",
                    fieldName: "name",
                    input: "text"
                  },
                  {
                    displayName: "Color",
                    input: "color"
                  }
                ],
                hiddenFunc: formData => this.hidden("options", formData)
              }
            ]
          }
        ]
      }
    };
  },
  components: {
    "fet-contenteditable": FETContenteditable,
    "fts-form": FTSForm,
    draggable,
    "v-select": vSelect,
    FTSNestedInformationModal
  },
  watch: {
    "formData.type": function() {
      if (this.formData.type == 27 && !this.formData.optionList) {
        this.formData.optionList = [];
      }
    },
    "formData": function() {
      console.log("change form data");
    }
  },
  methods: {
    getIcon(typeId) {
      return "icon-" + commons.getInformationIcon(typeId);
    },
    beforeOpen(event) {
      let payload = event.params;
      if (payload.item) {
        this.formData = _.cloneDeep(payload.item);
      }
    },
    formatSelection(formData) {
      return commons.dateFormats
    },
    hidden(type, formData) {
      if (type == "format") {
        if (formData.type == 5 || formData.type == 6) return false;
      } else if (type == "prefix") {
        if (formData.type == 4) return false;
      } else if (type == "withTime") {
        if (formData.type == 5 || formData.type == 6) return false;
      } else if (type == "allowMultiple") {
        if ([10, 12, 7, 20].some(y => formData.type == y)) return false;
      } else if (type == "lookup") {
        if ([7, 8, 20].some(y => formData.type == y)) return false;
      } else if (type == "formula") {
        if ([32].some(y => formData.type == y)) return false;
      } else if (type == "options") {
        if ([27].some(y => formData.type == y)) return false;
      }

      return true;
    },
    addInformation() {
      if (this.formData.fields == null) {
        this.formData.fields = [];
      }

      let informationField = _.cloneDeep(this.newInformation);
      informationField.id = commons.newUUID();
      delete informationField.typeModel;

      this.formData.fields.push({ information: informationField });
      // if (!this.newInformation.id) {
      //   this.$store.dispatch("confirmInformation", {
      //     information: this.newInformation
      //   });
      // }

      // this.activity.classification.push({
      //   id: commons.newUUID(),
      //   information: this.newInformation
      // });

      this.newInformation = {};
    },
    deleteInformation(information) {
      this.$modal.show("dialog", {
        title: "Confirmation",
        text: "Delete " + this.formData.displayName + " ?",
        buttons: [
          { title: "Cancel" },
          {
            title: "Delete",
            default: true,
            handler: () => {
              this.$store.dispatch("deleteInformation", {
                information: this.formData
              });
              this.$emit("informationDeleted", this.formData);
              this.$modal.hide("informationModal");
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    confirmInformation() {
      this.$store.dispatch("confirmInformation", {
        information: this.formData
      });
      this.$emit("informationConfirmed", {
        information: this.formData
      });
      this.$modal.hide("informationModal");
    },
    showInformation(item) {
      this.$modal.show("nestedInformationModal", { item });
    },
    close() {
      this.$modal.hide("informationModal");
    },
    deleteNested(nested) {
      this.formData.fields = this.formData.fields.filter(
        x => x.information.id != nested.id
      );
    },
    confirmNested(nested) {
      let field = this.formData.fields.find(x => x.information.id == nested.id);
      Object.assign(field.information, nested);
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/vars.scss";

.fts-information-modal {
  .class-info {
    margin-bottom: 2rem;
    .class-info-label {
      font-size: 0.875rem;
      color: $grayLightColor;
      letter-spacing: 0.09em;
    }
    .class-info-wrapper {
      display: flex;
      flex-wrap: wrap;
      padding: 6px;
      &:hover {
        background: #eeeeee;
      }
      .class-info-inner-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        .class-info-item {
          .class-info-display-name {
            display: flex;
            align-items: center;
            color: $darkColor;
            .class-info-icon {
              display: inline-flex;
              margin-right: 6px;
              color: $secondaryColor;
            }
          }
        }
        .class-info-setting {
          > svg {
            color: $grayLightColor;
            &.remove-action:hover {
              color: $dangerColor;
            }
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
    .class-info-action {
      display: flex;
      margin-top: 0.75rem;
      > input {
        margin-right: 6px;
        font-size: 0.875rem;
        max-width: 60%;
      }
      > .v-select {
        margin-right: 6px;
        flex: 1;
      }
    }
  }

  @media (min-width: 768px) {
    .fts-form-container .fts-form-item {
      .fts-form-element-container.compact-form-design .fts-form-label {
        min-width: 100px;
        width: 100px;
      }
    }
  }
}
</style>